import {
  buildAdminCoachMatchesRequest,
  type CoachMatch,
  parseAdminCoachMatchesResponse,
} from '@efdigital/ll-admin-v2/data/builders/coaching/admin-ai-matching';
import type AppSessionService from '@efdigital/ll-admin-v2/services/session';
import Service, { service } from '@ember/service';

export default class AdminAiMatchingService extends Service {
  @service declare session: AppSessionService;

  /**
   * Same ranked list the named coachee sees from the coachee coach-matches
   * route — one shared backend function, not a second scoring path.
   */
  async getCoachMatches(
    cohortId: string,
    coacheeId: string
  ): Promise<CoachMatch[]> {
    const request = await buildAdminCoachMatchesRequest(
      this.session,
      cohortId,
      coacheeId
    );
    const response = await fetch(request);
    return parseAdminCoachMatchesResponse(response);
  }
}

declare module '@ember/service' {
  interface Registry {
    'admin-ai-matching': AdminAiMatchingService;
  }
}
